import { useEffect, useState } from "react";
import { SimCard, useGetInventoryQuery } from "../../../api/slowboatApi";
import { message } from "antd";

export const TELECHOICE_PREFIX = "sb-esim-tc-"

/**
 * Auto-selects a Telechoice esim based on the confirmation code, that is
 * currently not assigned.
 */
export default function useTelechoice(sku?: string) {
  const { data } = useGetInventoryQuery();
  const [sel, setSel] = useState<SimCard>();
  useEffect(() => {
    setSel(undefined);
    if (sku === undefined || !sku.startsWith(TELECHOICE_PREFIX) || !data) {
      return;
    }
    const telcSims = data.filter(x => x.productCode === sku);
    console.log("telc sims", telcSims);
    const unused = telcSims.filter(x =>
      x.orderNumber.length === 0
      && x.expiryDate > new Date().toISOString().split("T")[0]
    );
    console.log("unused", unused, new Date().toISOString().split("T")[0]);
    unused.sort((a, b) => a.expiryDate.localeCompare(b.expiryDate));
    if (unused.length === 0) {
      message.error("Telechoice eSIMs for " + sku + " out of stock.");
      console.log(data);
      return;
    }
    const earliestExp = unused[0];
    const earliestExps = unused.filter(x =>
        x.expiryDate === earliestExp.expiryDate);
    const idx = Math.floor(Math.random() * earliestExps.length);
    const sim = earliestExps[idx];
    console.log("selected telechoice esim for sku " + sku, sim);
    setSel(sim);
  }, [data, sku]);
  return sel;
}